import styles from '../../styles/emailTemplateCard.module.css'
import { cn } from '@/lib/utils/helpers'
import type { EmailTemplateAddEditFormProps } from '../../types/components'
import { EmailTemplateFieldError } from './EmailTemplateFieldError'
import { EmailTemplateFormSection } from './EmailTemplateFormSection'

export function EmailTemplateMetadataSection({ page }: EmailTemplateAddEditFormProps) {
  const { workflowType, errors, registerField, showFieldError, fieldErrorMessage } = page

  if (!page.showMeta) return null

  return (
    <EmailTemplateFormSection
      testId="et-section-metadata"
      title={
        <>
          {workflowType === 'RESIDENT_NOT_PAID' ? 'Cron' : 'Application'} age (hours)
          <span className={styles.requiredStar}>*</span>
        </>
      }
    >
      <div className={styles.formRow}>
        <div className={cn(styles.formCol, styles.formColHalf)}>
          <div className={styles.formGroup}>
            <input
              type="number"
              min={1}
              className={cn(
                styles.customFormControl,
                'min-h-[2.375rem]',
                errors.template_metadata && '!border-red-500',
              )}
              placeholder="Hours"
              {...registerField('template_metadata')}
            />
            <EmailTemplateFieldError
              show={showFieldError('template_metadata')}
              message={fieldErrorMessage('template_metadata')}
            />
          </div>
        </div>
      </div>
    </EmailTemplateFormSection>
  )
}
